<template>
    <div>
        <div class="topFixed">
            <div class="head_header">
                <div class="container">
                    <div class="row">
                        <div class="col-12">

                    <div class="head_Menu_mobile clearfix">
                        <div class="mobile_Menu">
                            <span class="line"></span>
                            <span class="line"></span>
                            <span class="line"></span>
                        </div>
                    </div>
                     <div class="head_headerLogo clearfix">
                         <router-link v-if="!isPublicUser" class="head_mainLogo" :to="'/home'">
                             <img id="main-logo" :src="`/assets/branding/img/${branding_logo}`" alt="Elavon"/>
                         </router-link>
                         <a v-else class="head_mainLogo" href="#">
                             <img id="main-logo" :src="`/assets/branding/img/${branding_logo}`" alt="Elavon"/>
                         </a>
                     </div>
                    <div class="head_userSection clearfix">

                        <div class="row">
                            <div class="col-12">
                                <div class="float-right float-end d-inline-flex">
                                    <div class="" v-if="displayEnvInfo">
                                        <div :class="`environment-version color-env-${envInfo.environment.toLowerCase()}`">
                                            {{ envInfo.environment+' Feature:'+ envInfo.feature+' Version number:'+envInfo.version }}
                                        </div>
                                    </div>
                                    <div class="portalLangBtn">
                                        <div class="optionBtn">
                                            <a class="btn btn-sm btn-default btn-with-label" href="#"><span
                                                class="btn-label" v-if="supported_languages.length > 1"><i class="fa fa-caret-down"></i>  <i
                                                class="fa fa-globe fa-spin"></i></span>{{ lang(current_language) }}</a>
                                            <ul style="display: none;">
                                                <li v-for="lang in supported_languages">
                                                    <a :href="(supported_languages.length > 1 ? lang.url: '#')" >{{ lang.text }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="!isPublicUser" style="margin-left: 4px">
                                        <div class="row">
                                            <a class="nav-link toggler" href="#" data-bs-toggle=".userSection">
                                                <span style="color: black"> {{ user.fullname }}</span>
                                            </a>
                                        </div>
                                        <div class="row">
                                        <a href="/login/logout"> {{ lang('logout') }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Main Navigation -->
            <nav class="navbar navbar-expand-lg navbar-dark">
                <div class="container">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <div>
                            <p class="helpText">
                                <span>{{ lang('elavon_assistance') }} {{formatSupportPhone()}}</span>
                            </p>
                        </div>
                        <ul id="top-nav-tg" class="navbar-nav ms-auto">
                            <template v-if="!isPublicUser">
                                <li class="nav-item">
                                    <router-link class="nav-link" :to="'/home'">
                                        <i class="las la-home"></i> {{lang('home')}}
                                    </router-link>
                                </li>
                                <template v-for="menu in menuItems" >
                                <li class="nav-item" v-if="menu.display">
                                    <router-link class="nav-link" :to="menu.url">
                                        <i :class="menu.icon"></i> {{menu.label}}
                                    </router-link>
                                </li>
                                </template>
                            </template>
                            <template v-else>
                                <li class="nav-item">
                                    <a href="/loginotp" class="nav-link">
                                         {{ lang('login') }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </nav>
            <!-- User Menu -->
            <nav class="userSection slided">
                <ul class="container userMenu">
                    <li><a href="/myaccount/changepassword"><i class="fa fa-key fa-2x"></i><span class="notName">{{lang('password')}}</span></a></li>
                    <!-- <li><a href="/myaccount/changemfa"><i class="fa fa-key fa-2x"></i><span class="notName">{{lang('settings')}}</span></a></li> -->
                    <li><a href="/myaccount/mfdevices"><i class="fa fa-mobile fa-2x"></i><span class="notName">{{lang('mfa_devices')}}</span></a></li>
                    <li><a href="/login/logout"><i class="fa fa-power-off fa-2x"></i><span class="notName">{{lang('logout')}}</span></a></li>
                </ul>
                <i class="fa fa-times fa-2x float-end userMenuClose hidden-xs"></i>
            </nav>

            <!-- HeaderCopy -->
            <nav class="headerCopy">
                <div class="headerCopyIn container">

                </div>
            </nav>
            <div id="ajaxPreloader">
                <div class="ajaxPreloaderRails">
                    <div class="ajaxPreloaderStripe">
                    </div>
                </div>
            </div>
            <div class="ajaxModal">
                <div class="ajaxModalContainer container">

                </div>
            </div>

            <div class="alertBox displayNone">
                <div class="container alert_alertContainer alert alert-warning alert-dismissible" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    <ul>
                        <li><span>Warning:</span> No workflow has been configured so no dashboard data can be displayed.</li></ul></div></div>
        </div>
        <noscript>
            <p class="alert alert-danger text-center"><b>Your browser does not support JavaScript, this application cannot work without JavaScript</b></p>
        </noscript>
        <!--[if lt IE 10]>
        <div class="alert alert-danger text-center"><b>Your Internet Explorer browser is not up to date. Please update your Internet Explorer to version 10 or later.</b></div>
        <![endif]-->
        <div class="leftMenuMobile clearfix">
            <nav id="left-menu-mobile" class="closed">
                <template v-if="!isPublicUser">
                    <div class="nav closedEl">
                        <router-link class="menuHeaderThin" :to="'/home'">
                            <i class="flaticon-earth" style="font-size: 12px"></i> {{ lang('home') }}
                        </router-link>
                    </div>
                    <template v-for="menu in menuItems">
                    <div  class="nav closedEl" v-if="menu.display">
                        <router-link class="menuHeaderThin" :to="menu.url">
                            <i :class="menu.icon"></i> {{ menu.label }}
                        </router-link>
                    </div>
                    </template>
                    <div class="nav closedEl">
                        <a href="/login/logout" class="menuHeaderThin">
                            <i class="las la-power-off"></i> {{ lang('logout') }}
                        </a>
                    </div>
                </template>
                <template v-else>
                    <div class="nav closedEl">
                        <a class="menuHeaderThin" href="/login/longotp">
                            {{ lang('login') }}
                        </a>
                    </div>
                </template>
                <div class="helpDiv">
                    <p class="helpText">
                        <span>{{ lang('elavon_assistance') }} {{formatSupportPhone()}}</span>
                    </p>
                </div>
            </nav>

        </div>
    </div>
</template>

<script>
    import VueRouter from 'vue-router';
    export default {
        name: "np-navbar",
        data: () => {
            return {
            }
        },
        props: {
            menuItems: {
                default() {
                    return []
                }
            },
            permissions: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            user: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            my_language: {
                type: String,
                default: () => {
                    return 'en_gb';
                }
            },
            alliance_support: {
                type: Object,
                default() {
                    return {}
                }
            },
            language_options: {
                type: Array,
                default() {
                    return ['en_gb']
                }
            },
        },
        created() {
        },
        computed: {
            branding_logo: function () {
                if (this.$parent.parameters.hasOwnProperty('BRANDING') && !!this.$parent.parameters.BRANDING.branding_logo) {
                    return this.$parent.parameters.BRANDING.branding_logo;
                }

                return 'elavon_logo.png';
            },
            supported_languages: function(){
                let allowed_langs = ['en_gb', 'pl_pl', 'sv_se', 'no_no','de_de'] //'es_es', 'de_de', 'nl_nl',

                let alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
                if (alliance && alliance.hasOwnProperty('allowed_alt_languages') && !!(alliance.allowed_alt_languages)) {
                    allowed_langs = alliance.allowed_alt_languages.split(",")
                }

                let partner = this.user.hasOwnProperty('partner') ? this.user.partner : null;
                if (partner && partner.hasOwnProperty('allowed_alt_languages') && !!(partner.allowed_alt_languages)) {
                    allowed_langs = partner.allowed_alt_languages.split(",")
                }

                let payload = []

                this.language_options.map(lang => {
                    if (allowed_langs.findIndex(obj => {return obj === lang}) !== -1){
                        let temp = {}
                        temp.url = location.origin + "/myaccount/changelanguage/"+lang
                        temp.text = this.lang(lang)
                        temp.lang_code = lang
                        payload.push(temp)
                    }
                })

                //console.log(payload)
                return payload
            },
            current_language: function(){
                return this.my_language ? this.my_language : "en_gb";
            },
            displayEnvInfo: function(){
                return vue_data && vue_data.hasOwnProperty('ENV_INFO') && vue_data['ENV_INFO'].set && vue_data['ENV_INFO'].set === '1' && vue_data['ENV_INFO'].payload
            },
            envInfo: function(){
                let envData =  this.displayEnvInfo && vue_data['ENV_INFO'].payload ? vue_data['ENV_INFO'].payload : {}
                return envData
            },
            isPublicUser: function () {
                return this.user.is_public_user == '1';
            },
        },
        mounted() {
        },
        methods: {
            formatSupportPhone: function (){
                let formatted_support_phone = '0000 000 0000';
                let alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;

                if (alliance && alliance.hasOwnProperty('support_phone') && !!(alliance.support_phone)) {

                    let phone_no = alliance.support_phone;
                    if (phone_no.length >= 7) {
                        formatted_support_phone = phone_no.substring(0, 4) + ' ' + phone_no.substring(4, 7)
                            + ' ' + phone_no.substring(7, phone_no.length);
                    }
                    else {
                        formatted_support_phone = phone_no;
                    }

                    if (alliance.hasOwnProperty('support_phone_code') && !!(alliance.support_phone_code)) {
                        let phone_code = !!alliance.support_phone_code ? this.formatPhoneCode(alliance.support_phone_code) : '';
                        formatted_support_phone = phone_code + ' ' + formatted_support_phone;
                    }
                }
                return formatted_support_phone;
            },
            formatPhoneCode: function (data) {
                if (!!data && data !== "") {
                    return this.formatSelectType(this.$parent.parameters, data, 'PHONE_CODES')
                }
                    return '-';
                },
            }
    }
</script>

<style scoped>
.nav-link .las {
    font-size: 20px;
}

    .menuHeaderThin {
        width: 100%;
    }
    .helpText {
        margin-bottom: 0.2rem;
    }
    .helpText a, .helpText span {
        color: white;
        user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        -webkit-user-select: text;
    }

    nav#left-menu-mobile .helpDiv{
        position: absolute;
        bottom: 20px;
        width: 100%;
        height: 50px;
        margin-left: 5px;
    }
    .toggler {
      padding: 0px;
    }
</style>
